import { render } from "./LazyImage.vue?vue&type=template&id=36ca0c81&ts=true"
import script from "./LazyImage.vue?vue&type=script&lang=ts"
export * from "./LazyImage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__